/* eslint-disable no-plusplus */
import React, { useEffect } from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import cleanDeep from 'clean-deep';
import { usePaginatedQuery } from 'react-query'
import { Spacer } from 'components/atoms'
import { InputIcon, Pagination } from 'components/molecules'
import { PeopleTable } from 'components/organisms'
import {
  ALL_SUBWEB_PEOPLE,
  getPeople, PEOPLE_KEY, getSubwebPeople
} from 'services/requests'
import { useDebounce } from 'react-use'
import { useEditorContext } from 'context/EditorContext';

let peopleIDaux = [];
const PeopleList = ({
  subweb, lang, activePeopleId, isPeopleModule, onClickAdd, value
}) => {
  const [search, setSearch] = React.useState('')
  const [debouncedSearch, setDebouncedSearch] = React.useState('');
  const [page, setPage] = React.useState(1)
  const [{ peopleModuleselected }] = useEditorContext();

  const peopleID = peopleModuleselected;

  useEffect(() => {
    peopleIDaux = []
  }, []);

  useDebounce(
    () => {
      if (debouncedSearch !== search) setDebouncedSearch(search);
    },
    500,
    [search]
  );

  const {
    isLoading,
    isFetching,
    resolvedData,
    refetch
  } = usePaginatedQuery([isPeopleModule ? PEOPLE_KEY : ALL_SUBWEB_PEOPLE, {
    lang,
    ...((debouncedSearch !== '' && isPeopleModule) ? null : { subweb }),
    currentPage: page,
    search: debouncedSearch,
  }], isPeopleModule ? getPeople : getSubwebPeople)

  
  const totalRecords = React.useMemo(() => (
    resolvedData
      && resolvedData.data
      && resolvedData.data.pagination
      && resolvedData.data.pagination.totalRecords ? resolvedData.data.pagination.totalRecords : 0
  ), [resolvedData])

  const peopleComputed = React.useMemo(() => {
    if (
      resolvedData && resolvedData.data && resolvedData.data.data
      && resolvedData.data.data.length > 0
    ) {
      if (isPeopleModule) {
        let flag = true;
        // eslint-disable-next-line no-unused-expressions
        for (let i = 0; i < resolvedData.data.data.length; i++) {
          if (peopleID.length > 0) {
            flag = true;
            for (let j = 0; j < peopleID.length; j++) {
              if (
                resolvedData.data.data[i].photoId === peopleID[j].id 
              ) {
                resolvedData.data.data[i].check = true;
                resolvedData.data.data[i].disabledCheck = true;
              }
              else if (peopleIDaux.length > 0 && flag) {
                for (let k = 0; k < peopleIDaux.length; k++) {
                  if (
                    peopleIDaux[k].id === resolvedData.data.data[i].photoId) {
                    if (peopleIDaux[k].check === false || peopleIDaux[k].check === undefined) {
                      flag = false;
                      resolvedData.data.data[i].check = peopleIDaux[k].check;
                    }
                    else {
                      flag = false;
                      resolvedData.data.data[i].check = peopleIDaux[k].check;
                      resolvedData.data.data[i].disabledCheck = false;
                    }
                    
                  }
                }
              }
            }
          }
          else if (peopleIDaux.length > 0) {
            for (let t = 0; t < peopleIDaux.length; t++) {
              if (
                peopleIDaux[t].id === resolvedData.data.data[i].photoId 
              ) {
                resolvedData.data.data[i].check = peopleIDaux[t].check;
              }
            }
          }
        }
      }

      return resolvedData.data.data.map(({
        id,
        email,
        name,
        career,
        category,
        internalPhone,
        visible,
        check,
        photoId,
        disabledCheck,
        externalPhone
      }) => {
        const person = {
          id,
          name,
          category: category || career,
          phoneExtension: internalPhone,
          email: email.length >= 1 ? email[0] : null,
          isVisible: visible,
          check: !!check,
          photoId,
          disabledCheck: !!disabledCheck,
          externalPhone
        }
        return cleanDeep(person)
      }) 
    }
    return []
  }, [resolvedData])

  const handleSearch = (e) => {
    const searchValue = e.target.value
    setSearch(searchValue)
    setPage(1)
  }

  const setCheck = (i, id, check) => {
    let obj = {
      id,
      check
    }
    peopleIDaux.push(obj)
  }

  // react-table pages start at 0 while rc-pagination starts at 1
  const tablePage = React.useMemo(() => page - 1, [page])

  return (
    <>
      <Top>
        <InputIcon
          isLoading={isLoading || isFetching}
          icon="search"
          placeholder="pesquisar pessoas"
          value={search}
          onChange={handleSearch}
          modifiers={['stretch']}
        />
      </Top>
      <List>
        <Spacer bottom="m">
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
          />
        </Spacer>
        <PeopleTable
          data={peopleComputed}
          page={tablePage}
          loading={isLoading}
          subweb={subweb}
          activeRowId={activePeopleId}
          isPeopleModule={isPeopleModule}
          onClickAdd={onClickAdd}
          setCheck={setCheck}
          refetchData={() => refetch()}
        />
        <Spacer top="m">
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
          />
        </Spacer>
      </List>
    </>
  )
}

const Top = styled.div`
  width: 100%;
  padding-bottom: ${props => props.theme.spacing.l};
`;

Top.Start = styled.div``;
Top.End = styled.div`
  button {
    height: 100%;
  }
`;

const List = styled.div``

PeopleList.propTypes = {
  subweb: PropTypes.string,
  lang: PropTypes.string,
  activePeopleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

PeopleList.defaultProps = {
  subweb: 'ua',
  lang: 'pt',
  activePeopleId: null,
  isSubwebSet: false
}

export default PeopleList
